import React from 'react';
import PropTypes from 'prop-types';

import SubscriptionPlanContentsItem from '../molecules/SubscriptionPlanContentsItem';

const UserInfoPlanContents = ({ 
  tripTotalDays, 
  schedule, 
  outboundSessionFlight, 
  inboundSessionFlight, 
}) => {
  return (
    <React.Fragment>
      <div className="subscriptionPlanContentsContainer">
        {schedule && schedule.map((s, i) => {
          const dateDisplay = s.date.format('YYYY年M月D日');

          const outboundFlight = i === 0 ? outboundSessionFlight : null;
          const inboundFlight = i === tripTotalDays - 1 ? inboundSessionFlight : null;

          const index = i + 1;

          const { plan, planOptions: goods } = s;
          const questionAndAnswers = goods.map(good => good.questions);
          const planOptions = goods.map((good, index) => ({
            goods: good,
            itineraryIndex: index,
            peopleCounts: good.peopleCounts,
          }));

          return (
            <SubscriptionPlanContentsItem
              key={index}
              index={i + 1}
              outboundFlight={outboundFlight}
              inboundFlight={inboundFlight}
              dateDisplay={dateDisplay}
              plan={plan}
              planOptions={planOptions}
              handleOutboundFlightChange={() => {}}
              handleInboundFlightChange={() => {}}
              handlePlanChange={() => {}}
              handlePlanDelete={() => {}}
              cantChangeFlight={true}
              cantChangeHotel={true}
              cantDeleteHotel={true}
              handleUpdateCheckin={() => {}}
              finalConfirm={true}
              hideCheckin={!(plan && plan.firstDay)}
              handleUpdateQuestion={() => {}}
              showQuestions={!!(plan && plan.firstDay)}
              hideMessage={!(plan && plan.firstDay)}
              questionAndAnswers={questionAndAnswers}
              onQuestionAnswerChange={null}
              previousIsPlanOption={!!(planOptions && planOptions.length)}
            />
          );
        })}
      </div>
    </React.Fragment>
  );
};

UserInfoPlanContents.propTypes = {
  tripTotalDays: PropTypes.number.isRequired,
  schedule: PropTypes.array.isRequired,
  outboundSessionFlight: PropTypes.object.isRequired,
  inboundSessionFlight: PropTypes.object.isRequired,
};

export default UserInfoPlanContents;
